import React from "react"
import { Link, useLocation } from "react-router-dom"
import { PageHeader } from "@/components/ui/page-header"
import OrgUsersPanel from "@/components/settings/OrgUsersPanel"
import OrganizationSettings from "@/pages/OrganizationSettings"
import { cn } from "@/lib/utils"
import { Building2, Users } from "lucide-react"

const settingsNav = [
  { href: "/settings", label: "Organization", icon: Building2 },
  { href: "/settings/users", label: "Users", icon: Users },
]

export default function SettingsPage() {
  const location = useLocation()

  return (
    <div className="mx-auto max-w-7xl p-4 md:p-8">
      <PageHeader
        title="Settings"
        description="Manage your organization settings and preferences"
      />

      <div className="flex flex-col gap-4 mt-6 md:flex-row md:gap-8">
        {/* Settings Navigation: horizontal scrolling tab strip on phones, side rail on desktop */}
        <nav className="-mx-4 px-4 md:mx-0 md:px-0 md:w-56 md:shrink-0">
          <div className="flex gap-1 overflow-x-auto pb-1 md:flex-col md:space-y-1 md:overflow-visible md:pb-0">
            {settingsNav.map((item) => {
              const isActive = location.pathname === item.href
              const Icon = item.icon
              return (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    "flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2 text-sm transition-colors md:gap-3",
                    isActive
                      ? "bg-muted font-medium"
                      : "text-muted-foreground hover:bg-muted/50 hover:text-foreground"
                  )}
                >
                  <Icon className="h-4 w-4" />
                  {item.label}
                </Link>
              )
            })}
          </div>
        </nav>

        {/* Settings Content */}
        <div className="flex-1 min-w-0 space-y-6">
          {location.pathname === "/settings/users" ? (
            <OrgUsersPanel />
          ) : (
            <OrganizationSettings embedded />
          )}
        </div>
      </div>
    </div>
  )
}
